var Y = Object.defineProperty, Z = Object.defineProperties;
var x = Object.getOwnPropertyDescriptors;
var S = Object.getOwnPropertySymbols;
var J = Object.prototype.hasOwnProperty, K = Object.prototype.propertyIsEnumerable;
var H = (l, s, e) => s in l ? Y(l, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[s] = e, d = (l, s) => {
  for (var e in s || (s = {}))
    J.call(s, e) && H(l, e, s[e]);
  if (S)
    for (var e of S(s))
      K.call(s, e) && H(l, e, s[e]);
  return l;
}, P = (l, s) => Z(l, x(s));
var N = (l, s) => {
  var e = {};
  for (var o in l)
    J.call(l, o) && s.indexOf(o) < 0 && (e[o] = l[o]);
  if (l != null && S)
    for (var o of S(l))
      s.indexOf(o) < 0 && K.call(l, o) && (e[o] = l[o]);
  return e;
};
import { jsx as g, jsxs as W } from "react/jsx-runtime";
import { useRef as B } from "react";
import { c as G, e as ss } from "./get-size-BzhHC8s2.js";
import { u as M, c as L } from "./use-styles-BXCSW-9F.js";
import { j as w, b as D, B as j } from "./factory-BnRIVbT0.js";
import { C as es } from "./CloseButton-D9b16xbu.js";
import { c as Q } from "./create-optional-context-CQ2ahjKQ.js";
import { I as ls } from "./InputBase-D95P7hmN.js";
import { u as as } from "./Input-DhXon_Er.js";
import { u as ts } from "./use-merged-ref-n551Tfbr.js";
const [os, k] = Q(), [is, rs] = Q();
var C = { root: "m_7cda1cd6", "root--default": "m_44da308b", "root--contrast": "m_e3a01f8", label: "m_1e0e6180", remove: "m_ae386778", group: "m_1dcfd90b" };
const ns = {}, ds = L((l, { gap: s }, { size: e }) => ({
  group: {
    "--pg-gap": s !== void 0 ? G(s) : G(e, "pg-gap")
  }
})), E = w((l, s) => {
  const e = D("PillGroup", ns, l), t = e, { classNames: o, className: c, style: p, styles: f, unstyled: u, vars: h, size: y, disabled: b } = t, v = N(t, ["classNames", "className", "style", "styles", "unstyled", "vars", "size", "disabled"]), i = k(), a = (i == null ? void 0 : i.size) || y || void 0, r = M({
    name: "PillGroup",
    classes: C,
    props: e,
    className: c,
    style: p,
    classNames: o,
    styles: f,
    unstyled: u,
    vars: h,
    varsResolver: ds,
    stylesCtx: { size: a },
    rootSelector: "group"
  });
  return /* @__PURE__ */ g(is, { value: { size: a, disabled: b }, children: /* @__PURE__ */ g(j, d(d({ ref: s, size: a }, r("group")), v)) });
});
E.classes = C;
E.displayName = "@mantine/core/PillGroup";
const cs = {
  variant: "default"
}, ps = L((l, { radius: s }, { size: e }) => ({
  root: {
    "--pill-fz": G(e, "pill-fz"),
    "--pill-height": G(e, "pill-height"),
    "--pill-radius": s === void 0 ? void 0 : ss(s)
  }
})), A = w((l, s) => {
  const e = D("Pill", cs, l), q = e, {
    classNames: o,
    className: c,
    style: p,
    styles: f,
    unstyled: u,
    vars: h,
    variant: y,
    children: b,
    withRemoveButton: v,
    onRemove: i,
    removeButtonProps: a,
    radius: r,
    size: t,
    disabled: n,
    mod: F
  } = q, R = N(q, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "variant",
    "children",
    "withRemoveButton",
    "onRemove",
    "removeButtonProps",
    "radius",
    "size",
    "disabled",
    "mod"
  ]), m = rs(), z = k(), T = t || (m == null ? void 0 : m.size) || void 0, V = (z == null ? void 0 : z.variant) === "filled" ? "contrast" : y || "default", $ = M({
    name: "Pill",
    classes: C,
    props: e,
    className: c,
    style: p,
    classNames: o,
    styles: f,
    unstyled: u,
    vars: h,
    varsResolver: ps,
    stylesCtx: { size: T }
  });
  return /* @__PURE__ */ W(
    j,
    P(d(P(d({
      component: "span",
      ref: s,
      variant: V,
      size: T
    }, $("root", { variant: V })), {
      mod: [
        { "with-remove": v && !n, disabled: n || (m == null ? void 0 : m.disabled) },
        F
      ]
    }), R), {
      children: [
        /* @__PURE__ */ g("span", P(d({}, $("label")), { children: b })),
        v && /* @__PURE__ */ g(
          es,
          P(d(d({
            variant: "transparent",
            radius: r,
            tabIndex: -1,
            "aria-hidden": !0,
            unstyled: u
          }, a), $("remove", {
            className: a == null ? void 0 : a.className,
            style: a == null ? void 0 : a.style
          })), {
            onMouseDown: (_) => {
              var I;
              _.preventDefault(), _.stopPropagation(), (I = a == null ? void 0 : a.onMouseDown) == null || I.call(a, _);
            },
            onClick: (_) => {
              var I;
              _.stopPropagation(), i == null || i(), (I = a == null ? void 0 : a.onClick) == null || I.call(a, _);
            }
          })
        )
      ]
    })
  );
});
A.classes = C;
A.displayName = "@mantine/core/Pill";
A.Group = E;
var U = { field: "m_45c4369d" };
const us = {
  type: "visible"
}, O = w((l, s) => {
  const e = D("PillsInputField", us, l), m = e, {
    classNames: o,
    className: c,
    style: p,
    styles: f,
    unstyled: u,
    vars: h,
    type: y,
    disabled: b,
    id: v,
    pointer: i,
    mod: a
  } = m, r = N(m, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "type",
    "disabled",
    "id",
    "pointer",
    "mod"
  ]), t = k(), n = as(), F = M({
    name: "PillsInputField",
    classes: U,
    props: e,
    className: c,
    style: p,
    classNames: o,
    styles: f,
    unstyled: u,
    rootSelector: "field"
  }), R = b || (t == null ? void 0 : t.disabled);
  return /* @__PURE__ */ g(
    j,
    P(d(d({
      component: "input",
      ref: ts(s, t == null ? void 0 : t.fieldRef),
      "data-type": y,
      disabled: R,
      mod: [{ disabled: R, pointer: i }, a]
    }, F("field")), r), {
      id: (n == null ? void 0 : n.inputId) || v,
      "aria-invalid": t == null ? void 0 : t.hasError,
      "aria-describedby": n == null ? void 0 : n.describedBy,
      type: "text",
      onMouseDown: (z) => !i && z.stopPropagation()
    })
  );
});
O.classes = U;
O.displayName = "@mantine/core/PillsInputField";
const ms = {}, X = w((l, s) => {
  const a = D("PillsInput", ms, l), {
    children: o,
    onMouseDown: c,
    onClick: p,
    size: f,
    disabled: u,
    __staticSelector: h,
    error: y,
    variant: b
  } = a, v = N(a, [
    "children",
    "onMouseDown",
    "onClick",
    "size",
    "disabled",
    "__staticSelector",
    "error",
    "variant"
  ]), i = B(null);
  return /* @__PURE__ */ g(os, { value: { fieldRef: i, size: f, disabled: u, hasError: !!y, variant: b }, children: /* @__PURE__ */ g(
    ls,
    P(d({
      size: f,
      error: y,
      variant: b,
      component: "div",
      ref: s,
      onMouseDown: (r) => {
        var t;
        r.preventDefault(), c == null || c(r), (t = i.current) == null || t.focus();
      },
      onClick: (r) => {
        var n;
        r.preventDefault();
        const t = r.currentTarget.closest("fieldset");
        t != null && t.disabled || ((n = i.current) == null || n.focus(), p == null || p(r));
      }
    }, v), {
      multiline: !0,
      disabled: u,
      __staticSelector: h || "PillsInput",
      withAria: !1,
      children: o
    })
  ) });
});
X.displayName = "@mantine/core/PillsInput";
X.Field = O;
export {
  A as P,
  X as a
};
